// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-treeview {
    padding: 18px 12px;
    background-color: #EDECED;
    overflow-y: auto;
    width: 100%;
    align-self: stretch;
    flex-grow: 2;
}

.aiiif-treeview  .lds-ripple div {
    border-color: darkgray !important;
}

.aiiif-treeview-item {
    padding: 2px 6px;
    cursor: pointer;
    display: inline-flex;
}


.aiiif-treeview-item.aiiif-current {
    background-color: #7CD6FA;
    border-radius: 4px;
}

.aiiif-no-caret {
    background: none !important;
    width: 33px;
}

.aiiif-treeview-caret {
    margin: -4px -2px -4px -6px;
}

.aiiif-treeview-label {
    vertical-align: middle;
    word-break: break-all;
    line-height: 24px;
}

a {
    text-decoration: none;
}

.aiiif-label {
    margin: 9px 0 3px 0;
    font-weight: bold;
}

.aiiif-value {
    margin: 0 0 6px 0;
}
`, "",{"version":3,"sources":["webpack://./src/treeView/treeview.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;;AAGA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".aiiif-treeview {\n    padding: 18px 12px;\n    background-color: #EDECED;\n    overflow-y: auto;\n    width: 100%;\n    align-self: stretch;\n    flex-grow: 2;\n}\n\n.aiiif-treeview  .lds-ripple div {\n    border-color: darkgray !important;\n}\n\n.aiiif-treeview-item {\n    padding: 2px 6px;\n    cursor: pointer;\n    display: inline-flex;\n}\n\n\n.aiiif-treeview-item.aiiif-current {\n    background-color: #7CD6FA;\n    border-radius: 4px;\n}\n\n.aiiif-no-caret {\n    background: none !important;\n    width: 33px;\n}\n\n.aiiif-treeview-caret {\n    margin: -4px -2px -4px -6px;\n}\n\n.aiiif-treeview-label {\n    vertical-align: middle;\n    word-break: break-all;\n    line-height: 24px;\n}\n\na {\n    text-decoration: none;\n}\n\n.aiiif-label {\n    margin: 9px 0 3px 0;\n    font-weight: bold;\n}\n\n.aiiif-value {\n    margin: 0 0 6px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
